import type { TeamAssistStats } from './assistTracker.types'

export const calculateTotalAssists = (
  teamId: string,
  assistData: TeamAssistStats | null
): number => {
  if (!assistData) {
    return 0
  }

  const regularAssists = assistData.stats?.assists || 0
  const postAssists = assistData.postStats?.assists || 0

  return regularAssists + postAssists
}
